import React, { useMemo } from 'react';
import './StarsLayer.css';

const Star = React.memo(({ x, y, delay }: { 
  x: number; 
  y: number;
  delay: number 
}) => (
  <div 
    className="star"
    style={{
      '--star-x': x,
      '--star-y': y,
      animationDelay: `${delay}s`
    } as React.CSSProperties}
  />
));

const StarsLayer = () => {
  const stars = useMemo(() => 
    Array.from({ length: 200 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: Math.random() * 5
    })),
  []);

  return (
    <div className="stars-layer">
      {stars.map(star => (
        <Star
          key={star.id}
          x={star.x}
          y={star.y}
          delay={star.delay}
        />
      ))}
    </div>
  );
};

export default React.memo(StarsLayer);
